(function () {
  // #region write functions here
  function washer_dryer_bundle_issues() {
    /**
     * @returns {("washer" | "dryer" | null)}
     */
    function getProduct() {
      if (location.pathname.indexOf("/products/prism-monsoon-washer") > -1) {
        return "washer";
      }
      if (location.pathname.indexOf("/products/prism-monsoon-dryer") > -1) {
        return "dryer";
      }
      if (location.pathname.indexOf("/products/prism-cyclone-washer") > -1) {
        return "cyclonewasher";
      }
      if (location.pathname.indexOf("/products/prism-cyclone-dryer") > -1) {
        return "cyclonedryer";
      }
      return;
    }

    const washer = {
      wf85_white: "46115862151395",
      wf85_spacegrey: "46115862184163",
      wf95_white: "46115862216931",
      wf95_spacegrey: "46115862249699",
      wf105_white: "46115852353763",
      wf105_spacegrey: "46115852386531",
    };
    const dryer = {
      dh85_white: "48882229215459",
      dh85_spacegrey: "48882229248227",
      dh95_white: "48882229084387",
      dh95_spacegrey: "48882229117155",
      dh100_white: "46115550953699",
      dh100_spacegrey: "46115550986467",
    };
    const bundle = {
      bundle85_white: "46116935106787",
      bundle85_spacegrey: "46116935139555",
      bundle95_white: "46116935172323",
      bundle95_spacegrey: "46116935205091",
      bundle105_white: "46116935237859",
      bundle105_spacegrey: "46116935270627",
      cyclone_bundle115_spacegrey: "46302905270499",
      cyclone_bundle135_spacegrey: "46302905303267",
      cyclone_bundle115_black:     "46428696969443",
      cyclone_bundle135_black:     "46428697002211",
    };
    const cyclonewasher = {
      cyclone_wf115_black: "46301481763043",
      cyclone_wf135_black: "46301481894115",
    };
    const cyclonedryer = {
      cyclone_dh100_black: "46301508600035",
    };
    const product_image = {
      washer_white:
        "https://prismplus.sg/cdn/shop/files/MonsoonWF-White-Thumb1_1024x1024@2x.jpg?v=1772243242",
      washer_spacegrey:
        "https://prismplus.sg/cdn/shop/files/MonsoonWF-SpaceGrey-Thumb1_1024x1024@2x.jpg?v=1772243242",
      dryer_white:
        "https://prismplus.sg/cdn/shop/files/MonsoonDH-White-Thumb1_1024x1024@2x.jpg?v=1772243102",
      dryer_spacegrey:
        "https://prismplus.sg/cdn/shop/files/MonsoonDH-SpaceGrey-Thumb1_1024x1024@2x.jpg?v=1772243102",
      cyclone_dryer_black:
        "https://prismplus.sg/cdn/shop/files/CycloneWF-Thumb1_61eda31d-7723-4071-9013-8df4affc6799_1024x1024@2x.jpg?v=1772242807",
      cyclone_washer_black:
        "https://prismplus.sg/cdn/shop/files/CycloneDH-Thumb1_11196eed-2a62-4c63-893e-9f7bea0f6a69_1024x1024@2x.jpg?v=1772242697",
    };

    function handleVariantChange(page, variantId) {
      if (!variantId) return;

      function handleTopupAmount() {
        //console.log("Page:", page);
//console.log("Variant:", variantId);

        const topupAmount = $(".groupsell-addon-topup");
        if (!topupAmount) return;

        switch (page) {
          case "washer":
            switch (variantId) {
              case washer.wf85_white:
              case washer.wf95_white:
              case washer.wf105_white:
              case bundle.bundle85_white:
              case bundle.bundle95_white:
              case bundle.bundle105_white:
                topupAmount.text("$799");
                break;
              case washer.wf85_spacegrey:
              case washer.wf95_spacegrey:
              case washer.wf105_spacegrey:
              case bundle.bundle85_spacegrey:
              case bundle.bundle95_spacegrey:
              case bundle.bundle105_spacegrey:
                topupAmount.text("$819");
                break;
            }
            break;
          case "dryer":
            switch (variantId) {
              case dryer.dh100_white:
                topupAmount.text("$0");
                break;
              case dryer.dh100_spacegrey:
                topupAmount.text("$0");
                break;
              case bundle.bundle85_white:
                topupAmount.text("$0");
                break;
              case bundle.bundle95_white:
                topupAmount.text("$99");
                break;
              case bundle.bundle105_white:
                topupAmount.text("$199");
                break;
              case bundle.bundle85_spacegrey:
                topupAmount.text("$19");
                break;
              case bundle.bundle95_spacegrey:
                topupAmount.text("$119");
                break;
              case bundle.bundle105_spacegrey:
                topupAmount.text("$219");
                break;
            }
            break;
          case "cyclonewasher":
            switch (variantId) {

              case cyclonewasher.cyclone_wf115_black:
              case bundle.cyclone_bundle115_spacegrey:
              case bundle.cyclone_bundle115_black:
                topupAmount.text("$999");
                break;

              case cyclonewasher.cyclone_wf135_black:
              case bundle.cyclone_bundle135_spacegrey:
              case bundle.cyclone_bundle135_black:
                topupAmount.text("$1,099");
                break;

            }
            break;
          case "cyclonedryer":
            switch (variantId) {

              case cyclonedryer.cyclone_dh100_black:
                topupAmount.text("$999");
                break;

              case bundle.cyclone_bundle115_spacegrey:
              case bundle.cyclone_bundle115_black:
                topupAmount.text("$999");
                break;

              case bundle.cyclone_bundle135_spacegrey:
              case bundle.cyclone_bundle135_black:
                topupAmount.text("$1,099");
                break;

            }
            break;
        }
      }

      function handleImage() {
        const image = $(".bundled-addon-selectors .product-featured-img");
        if (!image) return;

        switch (page) {
          case "washer":
            switch (variantId) {
              case washer.wf85_white:
              case washer.wf95_white:
              case washer.wf105_white:
              case bundle.bundle85_white:
              case bundle.bundle95_white:
              case bundle.bundle105_white:
                image.attr("src", product_image.dryer_white);
                break;
              case washer.wf85_spacegrey:
              case washer.wf95_spacegrey:
              case washer.wf105_spacegrey:
              case bundle.bundle85_spacegrey:
              case bundle.bundle95_spacegrey:
              case bundle.bundle105_spacegrey:
                image.attr("src", product_image.dryer_spacegrey);
                break;
            }
            break;
          case "dryer":
            switch (variantId) {
              case dryer.dh85_white:
              case dryer.dh95_white:
              case dryer.dh100_white:
              case bundle.bundle85_white:
              case bundle.bundle95_white:
              case bundle.bundle105_white:
                image.attr("src", product_image.washer_white);
                break;
              case dryer.dh85_spacegrey:
              case dryer.dh95_spacegrey:
              case dryer.dh100_spacegrey:
              case bundle.bundle85_spacegrey:
              case bundle.bundle95_spacegrey:
              case bundle.bundle105_spacegrey:
                image.attr("src", product_image.washer_spacegrey);
                break;
            }
            break;
          case "cyclonewasher":
            switch (variantId) {
              case cyclonewasher.cyclone_wf115_black:
              case cyclonewasher.cyclone_wf135_black:
              case bundle.cyclone_bundle115_black:
              case bundle.cyclone_bundle135_black:
                image.attr("src", product_image.cyclone_washer_black);
                break;
            }
            break;
          case "cyclonedryer":
            switch (variantId) {
              case cyclonedryer.cyclone_dh100_black:
              case bundle.cyclone_bundle115_black:
              case bundle.cyclone_bundle135_black:
                image.attr("src", product_image.cyclone_dryer_black);
                break;
            }
            break;
        }
      }

      function handleCVSection() {
        const cv = $(".buy-with-climate-voucher-container");
        if (!cv) return;

        if (page === "dryer") {
          switch (variantId) {
            case bundle.bundle85_white:
            case bundle.bundle95_white:
            case bundle.bundle105_white:
            case bundle.bundle85_spacegrey:
            case bundle.bundle95_spacegrey:
            case bundle.bundle105_spacegrey:
              cv.show();
              break;
            default:
              //cv.hide();
              cv.show();
              break;
          }
        }
      }

      handleTopupAmount();
      handleImage();
      handleCVSection();
    }

    const page = getProduct();
    if (!page) return;

    const currentSelection = $("#currentSelection")[0];
    if (!currentSelection) return;

    const config = { attributes: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-variant"
        ) {
          handleVariantChange(page, $(mutation.target).attr("data-variant"));
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(currentSelection, config);
  }
  // #endregion

  // #region now call them
  washer_dryer_bundle_issues();
  // #endregion
})();
